import Vue from "vue";
import { mapState } from "vuex";
const ApiService = require("../../services/ApiService");

import TranslationService from "../../services/TranslationService";

export default Vue.component("contact-wish-input", {

    props:
    {
        template:
        {
            type: String,
            default: "#vue-contact-wish-input"
        }
    },

    data()
    {
        return {
            storedAt: "",
            saveTimeout: null,
            localContactWish: ""
        };
    },

    computed:
    {
        ...mapState({
            contactWish: state => state.checkout.contactWish
        }),

        storedAtText()
        {

            return this.storedAt
                ? `${ TranslationService.translate("Ceres::Template.checkoutUpdatedAt") } ${ this.storedAt } Uhr`
                : "";
        }
    },

    created()
    {
        this.localContactWish = this.contactWish;
    },

    methods: {
        updateContactWish()
        {
            if (this.localContactWish === this.contactWish)
            {
                return;
            }

            this.$store.commit("setContactWish", this.localContactWish);

            ApiService.post("/rest/io/order/contactWish", { orderContactWish: this.localContactWish })
                .done(() => this.setSaveDate())
                .fail(() => console.error("Failed."));
        },

        setSaveDate()
        {
            if (this.$refs.bkmContactWishStoredAt)
            {
                $(this.$refs.bkmContactWishStoredAt).hide();
                this.storedAt = new Date().toLocaleTimeString(
                    "de-DE",
                    { hour12: false, hour: "numeric", minute: "numeric", second:"numeric" }
                );
                $(this.$refs.bkmContactWishStoredAt).fadeIn();
            }
        },
        onInput()
        {
            if (this.saveTimeout)
            {
                clearTimeout(this.saveTimeout);
            }

            this.saveTimeout = setTimeout(() =>
            {
                this.updateContactWish();
            }, 500);
        },

        forceSave()
        {
            if (this.saveTimeout)
            {
                clearTimeout(this.saveTimeout);
                this.saveTimeout = null;
            }
            this.updateContactWish();
        }
    }
});
